<template><svg xmlns="http://www.w3.org/2000/svg" width="33.781" height="36.032" viewBox="0 0 33.781 36.032">
    <g transform="translate(1.018 1)">
        <g transform="translate(0)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
            <path d="M409.5,1690.248v13.612H423.11A13.611,13.611,0,0,0,409.5,1690.248Z"
                  transform="translate(-391.346 -1690.248)"/>
            <path d="M411.108,1708.36v-13.612a13.612,13.612,0,1,0,8.41,24.315Z"
                  transform="translate(-397.497 -1687.94)"/>
            <path d="M423.11,1702.248H409.5l8.41,10.7A13.592,13.592,0,0,0,423.11,1702.248Z"
                  transform="translate(-391.346 -1684.098)"/>
        </g>
    </g>
</svg>
</template>